import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ReportsPage from '../../pages/features/reports/ReportsPage'

export default function ReportsNav() {
    return (
        <Routes>
            <Route path="/" element={<ReportsPage />} />

        </Routes>
    )
}
